export default __webpack_public_path__ + "static/media/pic_copyright.6484e516.png";